import {Component, Input, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {ISaleOrder} from '../../../models/sale-order.interface';
import {IParcelItem} from '../../../models/parcel-item';

@Component({
    selector: 'eci-sale-order-parcels',
    templateUrl: './sale-order-parcels.component.html',
    styleUrls: ['./sale-order-parcels.component.scss'],
})
export class SaleOrderParcelsComponent implements OnInit {

    @Input() public saleOrderInfo: ISaleOrder;

    public displayedColumns: string[] = [
        'parcelNumber',
        'weight',
        'length',
        'height',
        'width',
        'sku',
        'quantity',
    ];

    public dataSource: MatTableDataSource<IParcelItem> = new MatTableDataSource([]);

    ngOnInit(): void {
        const parcels = this.saleOrderInfo?.parcel || [];

        const skuByProductId = new Map<string, string>();
        (this.saleOrderInfo?.products || []).forEach((p: any) => {
            const sku = p?.product?.sku;
            if (p?.id != null && sku) {
                skuByProductId.set(String(p.id), sku);
            }
        });

        parcels.forEach((parcel: any) => {
            (parcel.items || []).forEach((it: any) => {
                if (!it.sku) {
                    const fallback = skuByProductId.get(String(it.saleOrderProductId));
                    if (fallback) {
                        it.sku = fallback;
                    }
                }
            });
        });

        this.dataSource.data = parcels;
    }

    getSkus(items: any[]): string {
        return items?.map(item => item.sku).join(', ') || '';
    }

    getQuantities(items: any[]): string {
        return items?.map(item => item.quantity).join(', ') || '';
    }

}
